import React from "react";

import { IColum } from "../../../../utils/copyToClipboardInXlsFormat";
import { CopyToClipboard } from "../../../../components/ui";
import { CENTS_IN_DOLLAR } from "../../../../constants";
import { getTimeByAmericaChicagoTz } from "../../../../utils/moment";
import { IntlFormatUSD } from "../../../../utils";
import EntriesIdWithPrefix, {
  getEntriesIdWithPrefix,
} from "../../../FundedCompliance/components/EntriesIdWithPrefix";

const getYesNoNA = (value: boolean | null) => (value === null ? "N/A" : value ? "Yes" : "No");

export const MASTER_BAN_LIST_COLUMNS: Array<IColum> = [
  {
    by: "compliance_entries_id",
    title: "Entries ID",
    path: "account.compliance_traders_account.compliance_entries_id",
    isSortable: true,
    getCellValue: (value) => <EntriesIdWithPrefix entriesId={value as unknown as number} />,
    copyToClipBoardCallBack: (value) => getEntriesIdWithPrefix(value as unknown as number),
  },
  {
    by: "accounts_id",
    title: "Account ID",
    path: "accounts_id",
    getCellValue: (value) => <CopyToClipboard value={value as unknown as string} />,
    isSortable: true,
  },
  {
    by: "name",
    title: "Name",
    path: "account.name",
    getCellValue: (value) => <CopyToClipboard value={value as unknown as string} />,
    isSortable: true,
  },
  {
    by: "email",
    title: "Email",
    path: "account.email",
    getCellValue: (value) => <CopyToClipboard value={value as unknown as string} />,
    isSortable: true,
  },
  {
    by: "reason",
    title: "Reason",
    path: "reason",
    isSortable: true,
  },
  {
    by: "initiated_by",
    title: "Initiated by",
    path: "initiated_by",
    isSortable: true,
  },
  {
    by: "timestamp",
    title: "Ban date",
    path: "timestamp",
    isSortable: true,
    getCellValue: (value) => getTimeByAmericaChicagoTz(value as unknown as string, true),
    copyToClipBoardCallBack: (value) => getTimeByAmericaChicagoTz(value as string, true),
  },
  {
    by: "billing_sum_usd",
    title: "Billing sum",
    path: "account.billing_sum_usd",
    getCellValue: (value) => IntlFormatUSD(Number(value) / CENTS_IN_DOLLAR),
    copyToClipBoardCallBack: (value) => IntlFormatUSD(Number(value) / CENTS_IN_DOLLAR),
    isSortable: true,
  },
  {
    by: "is_active_subscription_canceled",
    title: "Active subscription canceled",
    path: "is_active_subscription_canceled",
    getCellValue: (value) => getYesNoNA(value as unknown as boolean),
    copyToClipBoardCallBack: (value) => getYesNoNA(value as unknown as boolean),
    isSortable: true,
  },
  {
    by: "is_blocked_access_to_account",
    title: "Blocked access to account",
    path: "is_blocked_access_to_account",
    getCellValue: (value) => getYesNoNA(value as unknown as boolean),
    copyToClipBoardCallBack: (value) => getYesNoNA(value as unknown as boolean),
    isSortable: true,
  },
  {
    by: "is_payment_method_removed",
    title: "Payment method removed",
    path: "is_payment_method_removed",
    getCellValue: (value) => getYesNoNA(value as unknown as boolean),
    copyToClipBoardCallBack: (value) => getYesNoNA(value as unknown as boolean),
    isSortable: true,
  },
  {
    by: "is_clear_last_account_config_request",
    title: "Clear last account config. request",
    path: "is_clear_last_account_config_request",
    getCellValue: (value) => getYesNoNA(value as unknown as boolean),
    copyToClipBoardCallBack: (value) => getYesNoNA(value as unknown as boolean),
    isSortable: true,
  },
  {
    by: "is_blocked_in_psp",
    title: "Blocked In PSP",
    path: "is_blocked_in_psp",
    getCellValue: (value) => getYesNoNA(value as unknown as boolean),
    copyToClipBoardCallBack: (value) => getYesNoNA(value as unknown as boolean),
    isSortable: true,
  },
  {
    by: "e2t_refund",
    title: "E2T refund",
    path: "e2t_refund",
    getCellValue: (value) =>
      value === null ? "N/A" : IntlFormatUSD(Number(value) / CENTS_IN_DOLLAR),
    copyToClipBoardCallBack: (value) =>
      value === null ? "N/A" : IntlFormatUSD(Number(value) / CENTS_IN_DOLLAR),
    isSortable: true,
  },
  {
    by: "e2t_refunded",
    title: "E2T Refunded",
    path: "e2t_refunded",
    getCellValue: (value) =>
      value === null ? "N/A" : getTimeByAmericaChicagoTz(value as unknown as string, true),
    copyToClipBoardCallBack: (value) =>
      value === null ? "N/A" : getTimeByAmericaChicagoTz(value as unknown as string, true),
    isSortable: true,
  },
];
